// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2LLLB","bigColWidth":"Table_bigColWidth__RLnWJ","biggerColWidth":"Table_biggerColWidth__3SJ3J","row":"Table_row__2COpQ","col":"Table_col__2yRV-"};